//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
SPLM.AME.PrimitiveSheetElementBuilderOfNoteLetteringangle = Object.freeze({
    "Invalid" : "Invalid", "NoValue" : "NoValue", "Degree0" : "Degree0", "Degree45" : "Degree45", "Degree90" : "Degree90", "Degree135" : "Degree135", "Degree180" : "Degree180", "Degree225" : "Degree225", "Degree270" : "Degree270", "Degree315" : "Degree315"});

SPLM.AME.PrimitiveSheetElementBuilderOfNoteAnchor = Object.freeze({
    "Invalid" : "Invalid", "NoValue" : "NoValue", "TopLeft" : "TopLeft", "TopCenter" : "TopCenter", "TopRight" : "TopRight", "MiddleLeft" : "MiddleLeft", "MiddleCenter" : "MiddleCenter", "MiddleRight" : "MiddleRight", "BottomLeft" : "BottomLeft", "BottomCenter" : "BottomCenter", "BottomRight" : "BottomRight"});

export default SPLM;